import { IDecorationCitation } from '../models';
import { DecorationsState } from './decorators.state';
import { initialLoadingState } from '../const';

const trackChangeData = {
  commentThreads: [],
  suggestions: [],
};

export const readonlyContent = {
  trackChangeData,
  docContent: '',
  loaded: false,
};

const citations: IDecorationCitation = {
  references: [],
  unnumbered_references: [],
  prefix: '',
  sufix: '',
  counterCase: '',
  referencePrefix: 'number',
  unnumberReferencePrefix: 'dash',
  isCitationUpdated: false,
  fragmentLinks: {
    incomingLinks: [],
    outgoingLinks: [],
  },
  deletedCitationFromRHP: undefined,
};

export const initialState: DecorationsState = {
  nodeId: null,
  initialLoadingState: { ...initialLoadingState },
  documentContent: '',
  citations,
  isEditable: false,
  isCopyEnable: false,
  referenceEditor: {
    isReferenceEditorClicked: false,
    referenceEditorInstance: null,
  },
  trackChangeData,
  usersInfo: [],
  readonlyContent,
  undoStackIndex: 0,
  citationStack: [],
  unNumberedCitationStack: [],
  unNumRefUndoStackIndex: 0,
  citationTabIndex: 0,
  isInfoDrawerToggled: false,
  subTemplates: [],
  keywords: [],
  trackChangeRHPData: trackChangeData,
  selectedCommentsTabIndex: 0,
  userPreferenceForTrackChangesView: '',
  documentValidationStatus: {
    status: '',
    validationResults: [
      {
        subject: '',
        status: '',
        text: '',
      },
    ],
  },
  cmTitle: '',
  baseHrefForLinkPlugin: '',
  baseHrefPathUrl: '',
  baseHrefId: '',
};
